import React, { useState } from 'react';
import WinnipegModal from 'components/LandingPageModal/WinnipegModal';
import Link from 'next/link';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';

const Configuration = props => {
  const [show, setShow] = useState('none');
  const [openConfigurationModal, setOpenConfigurationModal] = useState(false);
  const data = props;

  const dataModal = {
    ConfigurationData: [
      {
        src: '/static/images/landingPages/s4.png',
      },
    ],
  };
  return (
    <>
      <div>
        <div className="w-full pt-3 px-2 sm-px-0" style={{ backgroundColor: '#161616' }}>
          <HeadingSection title="FOUR BEDROOM CONFIGURATION - MORE SPACE FOR ALL OF YOU!" bgcolor="black" />

          <div style={{ display: show }}>
            <WinnipegModal
              dataModal={dataModal.ConfigurationData}
              show={openConfigurationModal}
              setClose={setOpenConfigurationModal}
            />
          </div>

          <div className="container mx-auto  lg:px-4     " style={{ backgroundColor: '#161616' }}>
            <div className="grid md:grid-cols-2 px-4 gap-x-12 md:pb-5">
              <div
                onClick={() => {
                  setShow('flex');
                  setOpenConfigurationModal(true);
                }}
                className=" md:mt-1 w-full  px-mobile-explore ">
                  
                {data.img}
              </div>
              <div
                className=" pt-4 md:pt-0 px-mobile-explore 
               flex flex-col justify-center ">
                <div
                  onClick={() => {
                    setShow('flex');
                    setOpenConfigurationModal(true);
                  }}
                  style={{ cursor: 'pointer' }}>
                  <h1 className=" fs-res-24 font-normal" style={{ fontFamily: 'josefin Sans', color: '#f7f7f7' }}>
                    {data.title}
                  </h1>

                  <h5 className="fs-res-18 pl-1 md:pl-0" style={{ fontFamily: 'josefin Sans', color: '#f7f7f7' }}>
                    {' '}
                    per bedroom
                  </h5>
                </div>

                {data.description}
              </div>
             
          </div>
          <div className="text-center container pb-5 mx-auto w-full pt-5">
                {data.href ? (
                  <Link href={data.href}>
                    <button
                      type="button"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        fontWeight: '600',
                        paddingTop: '11px',
                        paddingBottom: '11px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                      }}
                      className="btn rounded-0   fs-16-18 mb-4 ">
                      {data.btnTxt}
                    </button>
                  </Link>
                ) : (
                  <a href={data.hrefExt} target="_blank" rel="noreferrer">
                    <button
                      type="button"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        fontWeight: '600',
                        paddingTop: '11px',
                        paddingBottom: '11px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                      }}
                      className="btn rounded-0   fs-16-18 mb-4 ">
                      {data.btnTxt}
                    </button>
                  </a>
                )}
              </div>
            </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default Configuration;
